module.exports = __webpack_public_path__ + "static/chip_xs-af2f95b26a763f0857e9b1cbaf2727af.svg";